/** Default launch-gate / coming-soon message (shared by popup and full-site gate). */
export const DEFAULT_LAUNCH_GATE_MESSAGE =
  "CoinMBX is presently in the pre-launch stage and is in the process of obtaining FIU-IND registration. Platform launch will commence upon completion of the applicable regulatory requirements.";

const LEGACY_LAUNCH_MESSAGES = new Set([
  "We're almost ready! Stay tuned for the official launch.",
  "We're putting the finishing touches on CoinMBX. Check back soon for the official launch.",
]);

/** Popup + full-site gate body copy (replaces legacy defaults still stored in admin). */
export function resolveLaunchGateMessage(message) {
  const trimmed = message?.trim();
  if (!trimmed || LEGACY_LAUNCH_MESSAGES.has(trimmed)) {
    return DEFAULT_LAUNCH_GATE_MESSAGE;
  }
  return trimmed;
}